import React from 'react'
import SingleContentPage from '../../global/singleContentPage'
import { useTranslation } from 'react-i18next'
const SingleStory = (props) => {
  const { story, languages } = props.pageContext
  const { t, i18n } = useTranslation()
  const lang = i18n.language
  console.log(story, "story")
  return (
    <SingleContentPage
      id={story.id}
      label={story.genre[lang].genre}
      labelLink={`${t('urls.genre')}${story.genre[lang].slug}/`}
      title={story.title}
      slug={story.slug}
      seoDescription={story.seoDescription}
      seoSummary={story.seoSummary}
      seoTitle={story.seoTitle}
      spiciness={story.spiciness}
      voices={story.voices}
      tags={story.fantasies.map(tag => {return {link: `${t('urls.fantasy')}${tag[lang].slug}/`, label: tag[lang].fantasy} })}
      coverImage600={`https://storage.googleapis.com/audiodesires-aab7f.appspot.com/stories/${story.id}/artwork/600/${story.imageUrl.split('/').pop().split('.')[0]}.webp`}
      coverImage450={`https://storage.googleapis.com/audiodesires-aab7f.appspot.com/stories/${story.id}/artwork/450/${story.imageUrl.split('/').pop().split('.')[0]}.webp`}
      coverAlt={`${story.title} Erotic Audio Story Audiodesires - ${story.mainFantasy.fantasy} Fantasy`}
      metaLinks={[
        {link: `${t('urls.scenario')}${story.scenario.slug}/`, label: story.scenario.scenario}, 
        {link: `${t('urls.fantasy')}${story.mainFantasy.slug}/`, label: story.mainFantasy.fantasy},
        {link: `${t('urls.accent')}${story.accent.slug}/`, label: story.accent.accent}
      ]}
      similarStories={story.moreLikeThis.similarStories}
      seriesStories={story.moreLikeThis.seriesStories}
      sameScenarioStories={story.moreLikeThis.sameScenarioStories}
      audioUrl={story.audioUrl}
      duration={story.duration}
      type="story"
      languages={languages}
    />
  )
}

export default SingleStory